// extracted by mini-css-extract-plugin
export default {"container":"CopyInput_container__TupIB","text":"CopyInput_text__idwo7"};